import global from "../../global.js";
const d3 = global.d3;

const Clickable = function({name, target, handler, data}) {
    let enabled = false;

    Object.defineProperty(this, "enabled", {
        set: () => {},
        get: () => enabled
    });

    Object.defineProperty(this, "name", {
        set: () => {},
        get: () => name
    });

    this.enable = () => {
        if (!enabled) {
            if (target.constructor.name === "Selection") {
                target.on("click", () => {
                    handler(data);
                });
            } else if (target.constructor.name === "Object") {
                let {layer, selector} = target;
                layer.group.selectAll(selector).on("click", () => {
                    handler(data);
                });
                layer.on("creating", (handle) => {
                    d3.select(handle).select(selector).on("click", () => {
                        handler(data);
                    });
                });
                layer.on("deleting", (handle) => {
                    d3.select(handle).select(selector).on("click", null);
                });
            }
            enabled = true;
        }
    };

    this.disable = () => {
        if (enabled) {
            if (target.constructor.name === "Selection") {
                target.on("click", null);
            } else if (target.constructor.name === "Object") {
                let {layer, selector} = target;
                layer.group.selectAll(selector).on("click", null);
                layer.on("creating", null);
                layer.on("deleting", null);
            }
            enabled = false;
        }
    };
};

export default Clickable;
